import Keycloak from 'keycloak-js';
import Components from 'mpm-components';
import MPMContext from 'mpm-config/context/MPMContext';
import Routes from 'mpm-config/Routes';
import Utilities from 'mpm-config/Utilities';
import Pages from 'mpm-pages';
import Services from 'mpm-services';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

class App extends React.Component {
    static contextType = MPMContext;

    constructor(props) {
        super(props);
        this.state = {
            error: false,
        };
    }

    // Call To get Connected User DATA
    componentDidMount() {
        if (process.env.REACT_APP_KEYCLOAK === 'true') {
            const keycloakConfig = {
                url: process.env.REACT_APP_KEYCLOAK_URL,
                realm: process.env.REACT_APP_KEYCLOAK_REALM,
                clientId: process.env.REACT_APP_KEYCLOAK_CLIENTID,
            };
            const keycloak = new Keycloak(keycloakConfig);
            keycloak
                .init({ onLoad: 'login-required', checkLoginIframe: false })
                .then((auth) => {
                    if (auth) {
                        window.keycloak = keycloak;
                        const tokenParsed = keycloak.tokenParsed;

                        const fullName = tokenParsed?.name || ''; // Default to an empty string if name is not available
                        const parts = fullName.trim().split(' ');
                        const nom = parts[0];
                        const prenom = parts.length > 1 ? parts.slice(1).join(' ') : ''; // In case there are middle names

                        let connectedUser = {
                            login: tokenParsed.preferred_username,
                            nom,
                            prenom,
                            email: '',
                            emailVerified: tokenParsed.email_verified,
                            lastConnexion: keycloak.tokenParsed.auth_time,
                            role: keycloak.realmAccess.roles,
                            token: keycloak.token,
                            firstConnexion: false,
                        };
                        Services.UserDataService.saveDateLogin(connectedUser.login, {
                            dateLogin: connectedUser.lastConnexion,
                            sessionid: keycloak.sessionId,
                        }).then((response) => {
                            Services.UserDataService.getLastConnection(connectedUser.login).then((res) => {
                                connectedUser.lastConnexion = res;
                                Services.UserDataService.getIsFirstConnection().then((result) => {
                                    connectedUser.firstConnexion = result;
                                    this.context.setUserData(connectedUser);
                                });
                            });
                        });

                        this.setState({ error: false });
                    }
                })
                .catch(() => {
                    this.setState({ error: true });
                });
        }
    }

    render() {
        return this.context.isAuthenticated ? (
            <Router>
                <Components.MainLayout>
                    {!this.context.connectedUser.firstConnexion && (
                        <Switch>
                            <Route exact={true} path="/" component={Pages.Dashboard} />
                            {Routes.map(
                                ({ key, path, component, exact = false, hidden = false, roles = [] }, i) =>
                                    !hidden && (
                                        <Route
                                            exact={exact}
                                            key={key}
                                            path={path}
                                            render={(props) =>
                                                Utilities.isAutorizedUser(this.context.connectedUser, roles, path) ? (
                                                    component(props)
                                                ) : (
                                                    <Components.Unautorized {...props} />
                                                )
                                            }
                                        />
                                    )
                            )}
                            {Routes.map((item) =>
                                item.children !== undefined
                                    ? item.children.map(({ key, path, component, exact = false, roles = [] }, i) => (
                                          <Route
                                              exact={exact}
                                              key={key}
                                              path={path}
                                              render={(props) =>
                                                  Utilities.isAutorizedUser(this.context.connectedUser, roles, path) ? (
                                                      component(props)
                                                  ) : (
                                                      <Components.Unautorized {...props} />
                                                  )
                                              }
                                          />
                                      ))
                                    : null
                            )}
                        </Switch>
                    )}
                    {this.context.connectedUser.firstConnexion && <Pages.Profile.ResetPassword />}
                </Components.MainLayout>
            </Router>
        ) : this.state.error ? (
            <Components.MPMError />
        ) : (
            <Components.MPMLoader hideLogo message={<FormattedMessage id="message.loader.default" />} />
        );
    }
}

export default App;
